@if (product.data.is_from_price) {
  <span class="o2 inline-block va-m m-r-1"
  >{{'from' | translate}}</span>
}
<!-- final price -->
<price class="inline-block price o1 va-m"
  [class.col-6]="product.orgPrice"
[value]="product.price"></price>
<!-- org price for discount -->
@if (product.orgPrice) {
  <price class="m-l-3 col-11 o2 inline-block va-m price line-through"
    [value]="product.orgPrice"
  ></price>
}
@if (product.orgPrice) {
  <div class="col-6 p3 m-t-1"
  >{{'Sale' | translate}}</div>
}